const t = (e = []) => {
  if (!e.length)
    return null;
  e.map((n) => {
    const a = new Image();
    return a.src = n, a;
  });
};
export {
  t as default
};
